import { createGlobalStyle } from 'styled-components';
import theme from './theme';

const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html, body {
    font-family: ${theme.fonts.body};
    font-size: 16px;
    line-height: 1.5;
    color: ${theme.colors.textPrimary};
    background: ${theme.colors.bgDarkGradient};
    min-height: 100vh;
    overflow-x: hidden;
  }

  body {
    &:before {
      content: '';
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: radial-gradient(circle at 50% 50%, rgba(26, 26, 46, 0.3) 0%, rgba(10, 10, 10, 0.6) 100%);
      pointer-events: none;
      z-index: -1;
    }
  }

  #root {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${theme.fonts.heading};
    font-weight: ${theme.fontWeights.bold};
    line-height: 1.2;
    margin-bottom: ${theme.space.md};
    letter-spacing: 0.05em;
    text-transform: uppercase;
  }

  h1 {
    font-size: ${theme.fontSizes['3xl']};
    background: linear-gradient(to right, ${theme.colors.primary}, ${theme.colors.secondary});
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-shadow: 0 0 10px rgba(0, 212, 255, 0.3);

    @media (min-width: ${theme.breakpoints.md}) {
      font-size: ${theme.fontSizes['4xl']};
    }
  }

  h2 {
    font-size: ${theme.fontSizes['2xl']};
  }

  h3 {
    font-size: ${theme.fontSizes.xl};
  }

  p {
    margin-bottom: ${theme.space.md};
  }

  a {
    color: ${theme.colors.primary};
    text-decoration: none;
    transition: ${theme.transitions.fast};

    &:hover {
      color: ${theme.colors.secondary};
      text-shadow: 0 0 8px rgba(0, 212, 255, 0.5);
    }
  }

  button {
    font-family: ${theme.fonts.heading};
    font-weight: ${theme.fontWeights.medium};
    background: linear-gradient(135deg, ${theme.colors.primary} 0%, ${theme.colors.secondary} 100%);
    color: ${theme.colors.textPrimary};
    border: none;
    border-radius: ${theme.radii.md};
    padding: ${theme.space.sm} ${theme.space.lg};
    cursor: pointer;
    transition: ${theme.transitions.normal};
    text-transform: uppercase;
    letter-spacing: 0.05em;
    position: relative;
    overflow: hidden;
    
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
      transition: ${theme.transitions.normal};
    }
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: ${theme.shadows.glow};
      
      &:before {
        left: 100%;
      }
    }
    
    &:active {
      transform: translateY(0);
    }
    
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  /* Custom scrollbar */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${theme.colors.bgDark};
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.primary};
    border-radius: ${theme.radii.full};
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${theme.colors.secondary};
  }

  /* Selection styling */
  ::selection {
    background: ${theme.colors.secondary};
    color: ${theme.colors.textPrimary};
  }

  /* Utility classes */
  .text-gradient {
    background: linear-gradient(to right, ${theme.colors.primary}, ${theme.colors.secondary});
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .glow-text {
    text-shadow: 0 0 10px rgba(0, 212, 255, 0.5);
  }

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 ${theme.space.md};
  }
`;

export default GlobalStyles;